import React, { useEffect } from 'react'
import { useActions, useValues } from 'kea'
import { useSelector } from 'react-redux'
import ClickOutside from 'react-click-outside'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Close from 'lib/icons/close'

import Twicpics from 'lib/tags/twicpics'
import railsContext from 'lib/selectors/rails-context'
import routeSelector from 'lib/selectors/route-selector'

import CountriesMenu from './countries-menu'
import MenuElement from './menu-element'

import menuLogic from './logic'

const MenuElements = ({
  isLoggedIn,
  coursesCount,
  avatar,
  loginPath,
  signupPath,
  profilePath,
  firstName,
  mainMenuId,
  items
}) => {
  const { hideMenu, setActiveSubMenu } = useActions(menuLogic)
  const { visibleMenus, expandedMenuItem } = useValues(menuLogic)
  const { dpr } = useSelector(railsContext)
  const { pathname } = useSelector(routeSelector)

  const preventDefault = event => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleMenuElementClick = (menuItem, expandedMenuItem, event) => {
    if (menuItem.children) {
      preventDefault(event)
      setActiveSubMenu(menuItem.name === expandedMenuItem ? null : menuItem.name)
    }
  }

  useEffect(() => {
    const isMenuVisible = !!visibleMenus.filter(menuId => menuId === mainMenuId).length
    const body = document.getElementsByClassName('responsive layout-application')

    if (isMenuVisible && body[0]) {
      body[0].style.overflow = 'hidden'
    } else {
      body[0].style.overflow = 'unset'
    }
  }, [mainMenuId, visibleMenus])

  const closeMenu = (event, mainMenuId) => {
    const menuVisible = !!visibleMenus.filter(menuId => menuId === mainMenuId).length
    if (menuVisible) {
      hideMenu(mainMenuId)
      preventDefault(event)
    }
  }

  const isMenuVisible = !!visibleMenus.filter(menuId => menuId === mainMenuId).length

  return (
    <div>
      <div className={`main-menu-container ${isMenuVisible ? 'show' : 'hide'}`} />
      <div className={`main-menu ${isMenuVisible ? 'show' : 'hide'}`} data-attr='main-menu-menu'>
        <ClickOutside onClickOutside={event => closeMenu(event, mainMenuId)}>
          <div className='container'>
            <div className='main-menu-avatar'>
              <Close style={{ margin: 0 }} onClick={event => closeMenu(event, mainMenuId)} color='white' />
              {isLoggedIn || <a href='/' className='item main-menu-logo' />}
              {isLoggedIn && (
                <div className='main-menu-profile'>
                  <div className='main-menu-user-avatar'>
                    <a href={profilePath}>
                      <Twicpics
                        className='main-menu-profile-img'
                        alt='profile image'
                        src={avatar}
                        width={70}
                        height={70}
                        dpr={dpr}
                        style={{ display: 'block' }}
                      />
                    </a>
                  </div>
                  <a className='main-menu-user-name' href={profilePath}>
                    {I18n.t('profiles.hi_menu_message', { name: firstName })}
                  </a>
                </div>
              )}
            </div>
            {!isLoggedIn && (
              <div className='main-menu-logout-actions' data-attr='menu-actions'>
                <div className='main-menu-logout-actions-container'>
                  <a href={loginPath} data-attr='login-link'>
                    {I18n.t('devise.links.login')}
                  </a>
                  <a href={signupPath} data-attr='signup-link'>
                    {I18n.t('devise.links.join_free')}
                  </a>
                </div>
              </div>
            )}
            {isLoggedIn || (
              <ul>
                <CountriesMenu mainMenuId={mainMenuId} />
              </ul>
            )}
            <div>
              <ul>
                {items
                  .filter(menuItem => !menuItem.isButton)
                  .map((menuItem, index) => (
                    <MenuElement
                      key={`main-menu-item-${index}`}
                      coursesCount={coursesCount}
                      menuItem={menuItem}
                      pathname={pathname}
                      isExpanded={expandedMenuItem && expandedMenuItem.includes(menuItem.name)}
                      expandedMenuItem={expandedMenuItem}
                      handleMenuElementClick={handleMenuElementClick}
                      methodProps={
                        !menuItem.children && menuItem.method === 'delete'
                          ? {
                              'data-method': menuItem.method === 'delete' ? 'DELETE' : 'GET'
                            }
                          : {}
                      }
                    />
                  ))}
                {isLoggedIn && <CountriesMenu mainMenuId={mainMenuId} />}
                {items
                  .filter(menuItem => menuItem.isButton)
                  .map((menuItem, index) => (
                    <MenuElement
                      key={`main-menu-item-${index}`}
                      coursesCount={coursesCount}
                      menuItem={menuItem}
                      pathname={pathname}
                      isExpanded={expandedMenuItem && expandedMenuItem.includes(menuItem.name)}
                      expandedMenuItem={expandedMenuItem}
                      handleMenuElementClick={handleMenuElementClick}
                      methodProps={
                        !menuItem.children && menuItem.method === 'delete'
                          ? {
                              'data-method': menuItem.method === 'delete' ? 'DELETE' : 'GET'
                            }
                          : {}
                      }
                      isButton
                    />
                  ))}
              </ul>
            </div>
          </div>
        </ClickOutside>
      </div>
    </div>
  )
}

MenuElements.propTypes = {
  isLoggedIn: PropTypes.bool,
  coursesCount: PropTypes.number,
  avatar: PropTypes.string,
  loginPath: PropTypes.string,
  signupPath: PropTypes.string,
  profilePath: PropTypes.string,
  firstName: PropTypes.string,
  mainMenuId: PropTypes.string,
  items: PropTypes.array
}

export default MenuElements
